import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9bs9zcxru5: FaireBrandEntity = {
  token: "b_9bs9zcxru5",
  type: "brand",
  name: "The Sensory Riot",
  avatarUrl:
    "https://cdn.faire.com/fastly/8ddb987077b2227cb64cc0a70601bfb92a75fd619537f9f226642c3563885a88.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/719e16a55b52ae6e2029d51bf9d3507e800c75b1e0b088545ad46f4a74d71a9a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8ddb987077b2227cb64cc0a70601bfb92a75fd619537f9f226642c3563885a88.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/719e16a55b52ae6e2029d51bf9d3507e800c75b1e0b088545ad46f4a74d71a9a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "WELCOME TO THE SENSORY RIOT\nWe believe fragrance should do more than smell good - it should spark curiosity, electrify the room, and most of all, transport you somewhere you are not entirely sure you should go.\n\nNo rules. No boundaries. Just pure expression and olfactory fantasy.\n\nORIGINAL FORMULAS, ORIGINAL STORIES\nEach fragrance is designed to be intentionally unexpected.\n\nFamiliar notes are held close, then pushed into provocative territory, revealing a distinctly modern presence that defines our signature style.\n\nEvery creation is born from instinct and intuition, then refined with deliberate nuance to evolve in ways you may not expect.\n\n\nOUR SIGNATURE\nOur signature minimalist, burnt-sienna vessels seamlessly complement any modern space - strking an elegant statement before they are lit, then quietly stepping back to let the fragrance speak for itself.\n\n\nMETICULOUSLY CRAFTED\nEach candle is hand-poured using soy wax, braided cotton-core wicks, and a blend of essential oils and fine fragrance oils.\n\nFree of parabens, phthalates, lead, dyes, and never tested on animals.\n\nEvery fragrance is IFRA-certified, and without exception, formulated to be clean-burning, non-toxic, and safe for homes with children, pets, and scent-lovers alike. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:57.339Z",
    importedBy: "entity-db-cli",
  },
};
